import { RateCardManager } from "@/components/admin/RateCardManager";

export function SettingsRateCardPage() {
  return <RateCardManager />;
}
